import request from './client';

export function getUsers(options) {
  let page = options.page || 1;
  let search = options.search || "";
  let union = options.union_flg || "";
  let luxury = options.luxury_flg || "";
  let surveyType = options.survey_type || "";
  let zone = options.zone || "";
  let joinSurveys = options.join_surveys || "";
  let limit = options.limit || 10;
  return request({
    method: 'GET',
    url: '/api/v1/users' + '?page=' + page + '&limit=' + limit
          + (search !== "" ? '&search=' + search : "")
          + (union !== "" ? '&union_flg=' + union : "")
          + (surveyType !== "" ? '&survey_type=' + surveyType : "")
          + (zone !== "" ? '&zone=' + zone : "")
          + (joinSurveys !== "" ? '&join_surveys=' + joinSurveys: "")
          + (luxury !== "" ? '&luxury_flg=' + luxury : ""),
    responseType: 'json'
  });
}

export function getUser(id) {
  return request({
    method: 'GET',
    url: '/api/v1/users/' + id,
    responseType: 'json'
  });
}

export function updateUser(id, data) {
  return request({
    method: 'PUT',
    url: '/api/v1/users/' + id,
    data: data,
    responseType: 'json'
  });
}

export function getProperty(id) {
  return request({
    method: 'GET',
    url: '/api/v1/users/' + id + '/property',
    responseType: 'json'
  });
}

export function createProperty(id, data) {
  return request({
    method: 'POST',
    url: '/api/v1/users/' + id + '/property',
    data: data,
    responseType: 'json'
  });
}

export function createUser(data) {
  return request({
    method: 'POST',
    url: '/api/v1/users',
    data: data,
    responseType: 'json'
  });
}



// WEBPACK FOOTER //
// ./src/gateways/users.js